/**
 * Workflows API client. Thin wrappers over the shared `apiFetch` helper (see
 * ./api) that map to the Elysia /workflows module.
 */
import type {
  NewWorkflowInput,
  Paginated,
  UpdateWorkflowInput,
  WorkflowDetail,
  WorkflowRunDto,
  WorkflowSummary,
  WorkflowTestResult,
} from '@fc/core'
import { apiFetch } from './api'

export type {
  NewWorkflowInput,
  UpdateWorkflowInput,
  WorkflowActionDto,
  WorkflowActionInput,
  WorkflowActionType,
  WorkflowDetail,
  WorkflowRunDto,
  WorkflowStepResult,
  WorkflowSummary,
  WorkflowTestResult,
  WorkflowTrigger,
  WorkflowTriggerType,
} from '@fc/core'

export const listWorkflows = async (): Promise<WorkflowSummary[]> => {
  const data = await apiFetch<Paginated<WorkflowSummary>>('/workflows')
  return data.items
}

export const getWorkflow = (id: string): Promise<WorkflowDetail> =>
  apiFetch<WorkflowDetail>(`/workflows/${id}`)

export const createWorkflow = (input: NewWorkflowInput): Promise<WorkflowDetail> =>
  apiFetch<WorkflowDetail>('/workflows', { method: 'POST', body: JSON.stringify(input) })

export const updateWorkflow = (id: string, input: UpdateWorkflowInput): Promise<WorkflowDetail> =>
  apiFetch<WorkflowDetail>(`/workflows/${id}`, { method: 'PATCH', body: JSON.stringify(input) })

export const deleteWorkflow = (id: string): Promise<void> =>
  apiFetch<void>(`/workflows/${id}`, { method: 'DELETE' })

export const enableWorkflow = (id: string): Promise<WorkflowDetail> =>
  apiFetch<WorkflowDetail>(`/workflows/${id}/enable`, { method: 'POST' })

export const disableWorkflow = (id: string): Promise<WorkflowDetail> =>
  apiFetch<WorkflowDetail>(`/workflows/${id}/disable`, { method: 'POST' })

export const listWorkflowRuns = async (id: string): Promise<WorkflowRunDto[]> => {
  const data = await apiFetch<Paginated<WorkflowRunDto>>(`/workflows/${id}/runs`)
  return data.items
}

export const testWorkflow = (id: string, personId?: string): Promise<WorkflowTestResult> =>
  apiFetch<WorkflowTestResult>(`/workflows/${id}/test`, {
    method: 'POST',
    body: JSON.stringify(personId ? { personId } : {}),
  })
